import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { AlertService } from '../../providers/alert-service';
import { ModalBensServicosPage } from '../modais/modal-bens-servicos/modal-bens-servicos';
import { BensServicosService } from '../../providers/bens-servicos-service';
import { UsuarioService } from '../../providers/usuario-service';
import { MenuService } from '../../providers/menu-service';

/*
  Generated class for the TiposIrregularidade page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-bens-servicos',
  templateUrl: 'bens-servicos.html',
  providers: [
    BensServicosService
  ]
})
export class BensServicosPage {

  listaBensServicos: any;
  order: any = 'tipoBensServicos.dsTipoBensServicos';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public usuarioService: UsuarioService,
    public menuService: MenuService,
    public bensServicosService: BensServicosService,
    public modalCtrl: ModalController,
    public alertService: AlertService) {
    this.carregarPagina();
  }

  carregarPagina() {
    this.bensServicosService.listarBensServicos().subscribe(data => {
      this.listaBensServicos = data;
    }, error => console.log("erro: " + error));
  }

  deletarBensServicos(idBensServicos) {
    this.bensServicosService.deletarBensServicos(idBensServicos).subscribe(data => {
      this.alertService.mostraAlerta("", "Bens e Serviços Comuns deletado com sucesso!");
      this.carregarPagina();
    }, error => {
      this.alertService.mostraAlerta("", "Hove um erro ao remover bens e serviços comuns.");
      console.log("erro: " + error)
    });
  }

  inserirNovoBensServicos() {
    let parametroEnviado = this.bensServicosService.criaBensServicos();
    this.mostrarModal("Cadastro de Bens e Serviços Comuns", parametroEnviado);
  }

  editarBensServicos(parametroEnviado) {
    this.mostrarModal("Edição de Bens e Serviços Comuns", parametroEnviado);
  }

  mostrarModal(titulo, parametroEnviado) {
    let modal = this.modalCtrl.create(ModalBensServicosPage, { param1: titulo, param2: parametroEnviado });
    modal.onDidDismiss(retornoModal => {
      this.carregarPagina();
    });
    modal.present();
  }

  voltar() {
    // this.usuarioService.redirecionarHome(this.usuarioService.obterDadosUsuario);
    this.menuService.redirecionarPagina('964');
  }


}



// WEBPACK FOOTER //
// ./src/pages/bens-servicos/bens-servicos.ts